import { defineComponent as _defineComponent } from 'vue'
import { Tooltip } from 'element-ui'
import { PopoverPlacement } from 'element-ui/types/popover'
import { TooltipEffect } from 'element-ui/types/tooltip'
import { onMounted, shallowRef } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    content: { default: '' },
    effect: { default: 'dark' },
    placement: { default: 'top' }
  },
  setup(__props: any) {

const props = __props as { content: string, effect: TooltipEffect, placement: PopoverPlacement }



const tooltip = shallowRef<InstanceType<typeof Tooltip> & {
  referenceElm: HTMLElement | null;
  show: Function
  hide: Function
}>()
const contentRef = shallowRef<HTMLElement>()

onMounted(() => {
  // mounted后再手动绑定tooltip的referenceElm，否则组件内会直接绑定鼠标事件
  tooltip.value!.referenceElm = contentRef.value!
})

function handleMouseEnter() {
  const isOverflow = getIsOverflow()
  if(isOverflow && props.content) {
    tooltip.value!.show()
  }
}
function handleMouseLeave() {
  tooltip.value!.hide()
}
// 判断内容是否溢出
function getIsOverflow () {
  const range = document.createRange()
  const contentDom = contentRef.value!
  range.setStart(contentDom, 0)
  range.setEnd(contentDom, contentDom.childNodes.length)
  const rangeWidth = range.getBoundingClientRect().width
  const padding =
    (parseInt(getStyle(contentDom, 'paddingLeft') as string || '0', 10) || 0) +
    (parseInt(getStyle(contentDom, 'paddingRight') as string || '0', 10) || 0)
  return (rangeWidth + padding > contentDom.offsetWidth || contentDom.scrollWidth > contentDom.offsetWidth)
}
function getStyle(element: HTMLElement, styleName: string) {
  if (!element || !styleName) return null
  styleName = camelCase(styleName)
  if (styleName === 'float') {
    styleName = 'cssFloat'
  }
  try {
    var computed = document.defaultView?.getComputedStyle(element, '')
    return element.style[styleName as keyof CSSStyleDeclaration] || (computed ? computed[styleName as keyof CSSStyleDeclaration] : null)
  } catch (e) {
    return element.style[styleName as keyof CSSStyleDeclaration]
  }
}
function camelCase(name: string) {
  const SPECIAL_CHARS_REGEXP = /([:\-_]+(.))/g
  const MOZ_HACK_REGEXP = /^moz([A-Z])/
  return name.replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
    return offset ? letter.toUpperCase() : letter
  }).replace(MOZ_HACK_REGEXP, 'Moz$1')
}

return { __sfc: true,props, tooltip, contentRef, handleMouseEnter, handleMouseLeave, getIsOverflow, getStyle, camelCase }
}

})